module.exports = __webpack_public_path__ + "media/images/light_yellow_slant-f6d541909b3f1810ac65227f2b4dd749.svg";